import script from "./PlayoutSidebarTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutSidebarTabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__